import { BankAccountService } from "../services";

const extractBuildingId = (input) => {
  if (!input) return undefined;
  if (typeof input === "number") return input;
  if (typeof input === "object") {
    if (typeof input.buildingId === "number") return input.buildingId;
    if (typeof input.buildingId === "object") return input.buildingId?.id;
    if (typeof input.id === "number") return input.id;
    if (typeof input.building === "number") return input.building;
    if (typeof input.building === "object") return input.building?.id;
  }
  return undefined;
};

export const bankAccount = {
  state: () => ({
    bankAccounts: [],
    selectedBankAccounts: [],
    current: null,
  }),
  mutations: {
    setBankAccounts: (state, value) => (state.bankAccounts = value || []),
    setSelectedBankAccounts: (state, value) => (state.selectedBankAccounts = value || []),
    setCurrentBankAccount: (state, value) => (state.current = value || null),
  },
  actions: {
    BANKACCOUNT_FIND_ALL: async ({ commit }, params) => {
      const buildingId = extractBuildingId(params);
      if (!buildingId) {
        alert("Debe seleccionar un edificio para consultar las cuentas bancarias");
        return {
          ok: false,
          status: 400,
          message: "Debe indicar el identificador del edificio.",
        };
      }
      const response = await BankAccountService.findAll({ buildingId });
      if (response.ok) {
        commit("setBankAccounts", response.data || []);
      } else {
        alert(response.message || "No fue posible obtener las cuentas bancarias");
      }
      return response;
    },
    BANKACCOUNT_FIND_ONE: async ({ commit, rootState }, payload) => {
      const id = typeof payload === "object" ? payload?.id ?? payload : payload;
      let buildingId = extractBuildingId(payload?.buildingId ?? payload);
      if (!buildingId) {
        buildingId = extractBuildingId(rootState?.general?.selectedBuilding);
      }
      if (!buildingId) {
        alert("Debe seleccionar un edificio para consultar la cuenta bancaria");
        return {
          ok: false,
          status: 400,
          message: "Debe indicar el identificador del edificio.",
        };
      }
      const response = await BankAccountService.findById(id, { buildingId });
      if (response.ok) {
        commit("setCurrentBankAccount", response.data || null);
      } else {
        alert(response.message || "No fue posible obtener la cuenta bancaria");
      }
      return response;
    },
    BANKACCOUNT_CREATE: async ({ dispatch }, payload) => {
      const response = await BankAccountService.create(payload);
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("BANKACCOUNT_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    BANKACCOUNT_UPDATE: async ({ dispatch }, { id, ...payload }) => {
      const response = await BankAccountService.update({ id, ...payload });
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("BANKACCOUNT_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    BANKACCOUNT_DELETE: async ({ dispatch }, { id, buildingId }) => {
      const response = await BankAccountService.remove(id);
      if (response.ok) {
        const resolvedBuildingId = extractBuildingId(buildingId);
        if (resolvedBuildingId) {
          await dispatch("BANKACCOUNT_FIND_ALL", { buildingId: resolvedBuildingId });
        }
      }
      return response;
    },
    BANKACCOUNT_DOWNLOAD_EXCEL: async (_, payload) => BankAccountService.downloadExcel(payload),
  },
  getters: {
    bankAccountById: (state) => (id) =>
      state.bankAccounts.find((item) => item.id === id) || null,
  },
};
